import { useEffect, useState } from 'react';

/** Workspace gates must not block the shell longer than a Listen unary wait. */
export const WORKSPACE_GATE_MS = 12_000;

/** After `ms`, treat a boot gate as ready (fail-open on Cuba hangs). */
export function useFailOpenTimeout(active: boolean, ms = WORKSPACE_GATE_MS): boolean {
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (!active) {
      setTimedOut(false);
      return undefined;
    }
    setTimedOut(false);
    const id = window.setTimeout(() => setTimedOut(true), ms);
    return () => window.clearTimeout(id);
  }, [active, ms]);

  return timedOut;
}
